// Safe mode helper: keeps boot minimal when ?safe=1 is present.
const SAFE_MODE_PARAM = 'safe';
let cachedSafeMode: boolean | null = null;

const normalizeFlag = (value: string | null): boolean => {
  if (!value) return false;
  return value === '1' || value.toLowerCase() === 'true';
};

export const isSafeModeEnabled = (): boolean => {
  if (cachedSafeMode !== null) return cachedSafeMode;

  try {
    const url = new URL(window.location.href);
    cachedSafeMode = normalizeFlag(url.searchParams.get(SAFE_MODE_PARAM));
  } catch {
    cachedSafeMode = false;
  }

  return cachedSafeMode;
};

export const SAFE_MODE_QUERY_PARAM = SAFE_MODE_PARAM;
